import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCompliantStep } from "../../common/service/server/Types";

const getCompliantProgressSlice = createSlice({
  name: "getCompliantProgress",
  initialState: {
    progress: null as GetCompliantStep | null,
    hrProgress: null as GetCompliantStep | null,
  },
  reducers: {
    set: (
      state,
      action: PayloadAction<{
        progress: GetCompliantStep | null;
        hrProgress: GetCompliantStep | null;
      }>,
    ) => {
      if (action.payload.progress) {
        state.progress = action.payload.progress;
      }
      if (action.payload.hrProgress) {
        state.hrProgress = action.payload.hrProgress;
      }
      return state;
    },
    purge: (state) => {
      state = null;
      return state;
    },
  },
});

export const getCompliantProgressActions = getCompliantProgressSlice.actions;
export const getCompliantProgressReducer = getCompliantProgressSlice.reducer;
